module.exports = __webpack_public_path__ + "static/media/grph-stat-completion.e031e791.svg";